import React, {memo, useMemo} from "react";
import PropTypes from "prop-types";
import ReactApexChart from "react-apexcharts";
import {getOptions} from "./barsChartOptions";

export const BarsChart = memo(
    ({series = [], categories = []}) => {
        const options = useMemo(() => getOptions(categories), [categories]);

        return (
            <div id="chart" className="w-100">
                <ReactApexChart options={options} series={series} type="bar" height={450} />
            </div>
        );
    },
    (prevState, nextState) => prevState.series === nextState.series && prevState.categories === nextState.categories
);

BarsChart.propTypes = {
    series: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            data: PropTypes.arrayOf(PropTypes.number),
        })
    ),
    categories: PropTypes.arrayOf(PropTypes.string),
};
